import type { ButtonColor } from './colors';

export const secondaryColors: Partial<Record<ButtonColor, string>> = {
  brand: 'border-brand-primary-700 bg-brand-primary-50 text-brand-primary-700 hover:bg-brand-primary-100',
  gray: 'border-text-secondary-400 bg-background text-text-secondary-600 hover:bg-text-secondary-100',
  white:
    'border-text-inverse bg-white/20 text-text-inverse focus-visible:ring-white focus-visible:ring-offset-black hover:bg-white/30',
};
